import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logAPIError } from '../../../utils/logger';
import { ERROR_MESSAGE, IDEAS_TAG_TYPES } from '../constants';

export const serialize = ({ tag = '', type }) => ({ tag: tag.replace(/_/g, '-').toLowerCase(), type });

/**
 * Fetch buyer ideas by industry(tag)
 * @param {String} tag
 * @param {IDEAS_TAG_TYPES} type
 * @returns {Promise<SELLER_VARIATION[]>}
 */
const getIdeas = ({ tag, type = IDEAS_TAG_TYPES.INDUSTRY }) => {
    const requestUrl = pathfinder('logo_maker_buyer_ideas_ajax', { endpoint: 'ideas' });

    return axios.post(requestUrl, serialize({ tag, type }))
        .then(({ data }) => data)
        .catch((response) => {
            logAPIError(response, { message: ERROR_MESSAGE, tag, type });
        });
};

export default getIdeas;
